<div class="select-toggle">
    <app-dropdown-list
        [elementList]="specialFlags"
        [selectedElements]="selectedFlags"
        (elementClicked)="selectFlag($event)"
        [title]="getSelectTitle()"
        [labelKey]="'name'">
    </app-dropdown-list>
</div>
